var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobalMarketLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 40,
    viewBox: "0 0 153 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8435_105247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1421 0C99.8631 0.291767 100.913 0.701482 101.448 1.23846C105.786 5.57151 101.746 16.6369 92.6758 25.6941C83.6054 34.7544 72.5308 38.7895 68.193 34.4564C67.6554 33.9195 67.2452 32.8703 66.9531 32.1533C67.065 34.0436 67.0557 35.0182 68.2147 36.1729C72.8322 40.7853 84.606 36.9147 94.2574 27.274C103.909 17.6333 107.784 5.87259 103.166 1.26018C102.007 0.102429 101.035 0.111741 99.1421 0V0Z",
    fill: "url(#paint0_linear_8435_105247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.976 26.2498C23.6796 26.2498 22.9805 25.5235 22.9805 23.1304V19.7471C22.9805 17.3416 23.6796 16.6277 25.976 16.6277H31.3796C32.8059 16.6277 33.4647 17.5092 33.6884 18.04L32.4858 19.2691C32.3181 18.8904 31.9825 18.5273 31.2553 18.5273H25.9915C25.1525 18.5273 24.8573 18.8346 24.8573 19.744V23.1428C24.8573 23.9529 25.0251 24.3595 25.9915 24.3595H31.3237C32.0664 24.3595 32.374 23.9808 32.5418 23.6177L33.7443 24.8344C33.533 25.3652 32.8618 26.2467 31.4356 26.2467H25.976V26.2498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6854 5.72318C88.1501 5.18862 87.7406 2.85718 87.7406 2.85718C87.7406 2.85718 87.3311 5.19184 86.7958 5.72318C86.2605 6.25773 83.9258 6.6667 83.9258 6.6667C83.9258 6.6667 86.2637 7.07567 86.7958 7.61023C87.3311 8.14478 87.7406 10.4762 87.7406 10.4762C87.7406 10.4762 88.1501 8.14156 88.6854 7.61023C89.2207 7.07567 91.5554 6.6667 91.5554 6.6667C91.5554 6.6667 89.2175 6.25773 88.6854 5.72318Z",
    fill: "url(#paint1_linear_8435_105247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6855 24.3438V16.6306H55.5748V24.35H62.8274V26.2527H55.5966C54.5432 26.2527 53.6855 25.3991 53.6855 24.3438V24.3438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8829 26.2498C67.5462 26.2498 66.875 25.4955 66.875 23.1304V19.7471C66.875 17.385 67.5462 16.6277 69.8829 16.6277H74.9634C77.2598 16.6277 77.9745 17.3819 77.9745 19.7471V23.1304C77.9745 25.4924 77.2598 26.2498 74.9634 26.2498H69.8829ZM76.0852 19.7626C76.0852 18.8128 75.79 18.5335 74.951 18.5335H69.8829C69.0439 18.5335 68.7487 18.8128 68.7487 19.7626V23.1459C68.7487 24.0957 69.016 24.3626 69.8829 24.3626H74.951C75.818 24.3626 76.0852 24.0957 76.0852 23.1459V19.7626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9416 26.2496L81.6777 16.6306H83.9306L87.9328 24.1948L91.9351 16.6306H94.2035L88.9116 26.2496H86.9385H86.9416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.651 18.5333V16.6306H102.877C102.554 17.2607 102.206 17.8939 101.83 18.5333H108.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3984 22.1928V24.3313C99.3984 25.3898 100.259 26.2496 101.319 26.2496H108.652V24.3624H101.288V22.2083H108.441V20.6563H101.288V19.4241C100.71 20.3459 100.082 21.2709 99.3984 22.1896V22.1928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.659 23.4686C138.659 25.511 137.82 26.2497 135.524 26.2497H128.722C128.75 25.6196 128.806 24.9926 128.849 24.3625H135.399C136.422 24.3625 136.714 24.1235 136.714 23.301C136.714 22.4784 136.434 22.2394 135.44 22.2394H131.534C129.225 22.2394 128.482 21.4138 128.482 19.6539V19.3311C128.482 17.416 129.253 16.6338 131.59 16.6338H138.336C138.267 17.2763 138.18 17.9064 138.097 18.5489H131.587C130.664 18.5489 130.397 18.8438 130.397 19.598C130.397 20.3523 130.664 20.6596 131.587 20.6596H135.437C137.829 20.6596 138.656 21.4417 138.656 23.1334V23.4686H138.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.34 24.3593V18.5892C143.34 17.509 144.216 16.6306 145.301 16.6306H152.594V18.5333H145.229V20.6595H152.382V22.2114H145.229V24.3655H152.594V26.2527H145.232C144.188 26.2527 143.34 25.4053 143.34 24.3624V24.3593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2649 26.2496H49.4214L44.1451 16.6306H42.1689L36.8926 26.2496H39.0491L43.1632 18.5178",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.75 23.0774C123.13 23.0774 124.013 22.5467 124.013 20.197V19.6104C124.013 17.4283 123.298 16.6306 121.256 16.6306H113.389V18.5488H121.201C122.027 18.5457 122.139 18.9927 122.139 19.9301V20.3925C122.139 21.2306 121.872 21.5255 121.201 21.5255H113.389V26.2527H115.293V23.1054H118.332L121.664 26.2527H124.323L120.753 23.0774H120.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0143 16.6709C15.6736 16.6709 17.0191 15.3269 17.0191 13.6694C17.0191 12.012 15.6736 10.668 14.0143 10.668C12.3549 10.668 11.0095 12.012 11.0095 13.6694C11.0095 15.3269 12.3549 16.6709 14.0143 16.6709ZM17.134 23.574H11.1275C10.795 23.574 10.7484 23.4747 10.9162 23.186L14.5549 17.5648H8.42725L2.09447 27.3359C1.95153 27.5842 2.15973 27.8946 2.4456 27.8946H7.30239C7.63487 27.8946 7.7312 27.994 7.56651 28.2826L0.0156549 39.8353C-0.0464921 39.944 0.0902313 40.0557 0.183452 39.9719L17.3205 24.052C17.5069 23.8813 17.3857 23.5709 17.134 23.5709V23.574Z",
    fill: "url(#paint2_linear_8435_105247)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8435_105247",
    x1: 66.9562,
    y1: 19.0549,
    x2: 105.108,
    y2: 19.0549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FF2835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FF4128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FF6A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7510"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8435_105247",
    x1: 86.5055,
    y1: 4.78931,
    x2: 91.6571,
    y2: 10.5928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761051,
    stopColor: "#FF2E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8435_105247",
    x1: -0.835758,
    y1: 41.9367,
    x2: 18.1419,
    y2: 12.1325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF0900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FF4B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8435_105247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152.593,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalMarketLogo);
export default __webpack_public_path__ + "static/media/global-market-logo.870b730c8ff0fbfc0655c91b487b4842.svg";
export { ForwardRef as ReactComponent };